export const sessionTypeList = [
  {
    id: 'LIVE',
    name: 'LIVE'
  }
]

export const sessionPlatformList = [
  {
    id: 'HANGOUT',
    name: 'HANGOUT'
  },
  {
    id: 'WEBEX',
    name: 'WEBEX'
  },
  {
    id: 'ZOOM',
    name: 'ZOOM'
  }
]
